<div class="d-flex flex-wrap w-100">
	<div class="display-14 my-auto">
		<div>External links allow you to add links to your Canvas List in Online Ordering.</div>
		<div>Use links to send guests to your catering menu, location list, eGift page or anywhere you want.</div>
	</div>
	<div class="ms-auto my-auto">
		<app-record-control-footer
			[hideAdd]="false"
			[hideCancel]="true"
			[hideDelete]="true"
			[hideSave]="true"
			(onAddChange)="addExternalLink()"
		></app-record-control-footer>
	</div>
</div>
<div class="w-100">
	<p-divider></p-divider>
	<ng-container *ngFor="let rec of externalLinks; let idx = index">
		<div class="p-grid">
			<div class="p-col-12 p-md-4 mt-3">
				<span class="p-float-label mt-1">
					<input pInputText #externalLinkLabel name="externalLinkLabel" type="text" [(ngModel)]="rec.label" class="w-100" />
					<label for="externalLinkLabel">Label</label>
				</span>
			</div>
			<div class="p-col-12 p-md-4 mt-3">
				<span class="p-float-label mt-1">
					<input pInputText #externalLinkUrl name="externalLinkUrl" type="text" [(ngModel)]="rec.url" class="w-100" />
					<label for="externalLinkUrl">URL</label>
				</span>
			</div>
			<div class="p-col-12 p-md-4 mt-3">
				<app-record-control-footer
					[hideAdd]="true"
					[hideCancel]="true"
					[hideDelete]="false"
					[hideSave]="true"
					(onDeleteChange)="externalLinks.splice(idx, 1)"
				></app-record-control-footer>
			</div>
		</div>
	</ng-container>
</div>
